export default __webpack_public_path__ + "static/media/bw_photos_tikal-2.8fd65f72.jpg";